import React from 'react';
import PresetWSCIIcon from "../../../../ui/svg/preset/preset-wsci";
import PresetWSCRIcon from "../../../../ui/svg/preset/preset-wscr";

interface IPresetIcons {
    algType:string,
    width: string
}
const PresetIcons = (props: IPresetIcons) => {

    return (
        <>
            {props?.algType === "WSCR" && <PresetWSCRIcon width={props?.width}  />}
            {props?.algType === "WSCI" && <PresetWSCIIcon width={props?.width}  />}
        </>
    )
};

export default PresetIcons;